<template>
  <div class="list-group-item">
    <div class="row g-1">
      <div class="col-12" v-if="iconSrc">
        <img class="img-fluid" :src="iconSrc" alt="iconAlt" />
      </div>
      <div class="col-12 fs-5" v-html="message"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  iconSrc: {
    type: String,
    optional: true,
    default: null,
  },
  iconAlt: {
    type: String,
    optional: true,
    default: null,
  },
  message: {
    type: String,
    optional: true,
    default: "",
  },
});
</script>
<style scoped></style>
